<app-button
    variant="text"
    severity="secondary"
    iconOnly
    [ariaLabel]="(modal.maximized() ? 'common.minimize' : 'common.maximize') | translate"
    (click)="modal.toggleMaximized()"
>
    <cl-icon [icon]="modal.maximized() ? icons.Minimize : icons.Maximize" />
</app-button>
<app-button variant="text" severity="secondary" iconOnly [ariaLabel]="'common.close' | translate" (click)="closed.emit()">
    <cl-icon [icon]="icons.X" />
</app-button>
